<template>
	<div>
		<div v-if="wishlistData.length">
			<share-bundle :url="shareUrl"></share-bundle>
			<div ref="map" style="width: 100%; height: 50rem"></div>

			<div class="blocks blocks--wishlist">
				<div class="listing">
					<div class="listing__wrapper">
						<div class="listing__grid listing__grid--thirds">
							<div :key="i" v-for="(m,i) in wishlistData" class="listing__item">
								<div class="wishlist wishlist--wishlist">
									<div class="wishlist__container">
										<div class="wishlist__title">{{ markerLabels[i] }}</div>
										<div class="wishlist__line wishlist__line--remove">
											<div class="card__meta">
												<span class="card__wishlist card__wishlist--remove" v-if="wishlistReference == '' && wishlistShareReference != ''">
													<span class="wishlist__text">Remove</span>

													<span
														class="icon icon-heart wishlist__icon wishlist__icon--active"
														@click.prevent="removeFromWishlist(i, m.id)">

														<svg><use href="#icon-heart" /></svg>
													</span>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div v-html="m.cardHtml"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue"
import $http from "axios"
import { mapStyles, loadGoogleMaps } from "./../../utils"

export default {
	data() {
		return {
			state: this.$store.state,
			wishlistData: [],
			map: null,
			markers: [],
			infoWindow: null,
			markerLabels: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
		}
	},
	props: ["wishlistReference","wishlistShareReference"],
	computed: {
		shareUrl() {
			const siteData = document.querySelector('#siteData');
			return `${siteData?.dataset?.url}/wishlist?reference=${this.wishlistReference != '' ? this.wishlistReference : this.wishlistShareReference != '' ? this.wishlistShareReference : ''}`
		}
	},
	methods: {
		getWishlistItems() {
			$http.get(
				"/actions/simple/wishlist/items?reference=" + this.wishlistReference,
				{ responseType: "text" }
			).then(response => {
				this.wishlistData = response.data
				this.$nextTick(() => this.initMap())
			})
		},
		async initMap() {
			await loadGoogleMaps()
			if (!this.$refs.map) return

			this.map = new google.maps.Map(this.$refs.map, {
				center: { lat: -32.2315018, lng: 148.6329645 },
				zoom: 14,
				styles: mapStyles,
			})
			this.infoWindow = new google.maps.InfoWindow()
			this.addMarkers()
			setTimeout(() => this.setMapBounds(), 500)
		},
		addMarkers() {
			this.clearMarkers()
			this.wishlistData.forEach((item, i) => {
				if (!item.position || !item.position.lat || !item.position.lng) return
				const marker = new google.maps.Marker({
					position: { lat: parseFloat(item.position.lat), lng: parseFloat(item.position.lng) },
					map: this.map,
					label: {
						text: this.markerLabels[i] || String(i + 1),
						color: "white",
						fontSize: "12px",
						fontFamily: "Imprima, lato, bree, sans-serif",
					},
				})
				marker.addListener("click", () => {
					this.infoWindow.setContent(item.title || "")
					this.infoWindow.open(this.map, marker)
				})
				this.markers.push(marker)
			})
		},
		clearMarkers() {
			this.markers.forEach(m => m.setMap(null))
			this.markers = []
		},
		removeFromWishlist(index, id) {
			Vue.delete(this.wishlistData, index)
			this.addMarkers()
			this.setMapBounds()
			this.$store.toggleWishlistItemByIdAction(id)
		},
		setMapBounds() {
			if (!this.map || !this.wishlistData.length) return
			const bounds = new google.maps.LatLngBounds()
			this.wishlistData.forEach(item => {
				const lat = parseFloat(item.position && item.position.lat)
				const lng = parseFloat(item.position && item.position.lng)
				if (lat && lng) bounds.extend(new google.maps.LatLng(lat, lng))
			})
			this.map.fitBounds(bounds)
		},
	},
	mounted() {
		this.getWishlistItems()
	},
}
</script>
